import { NessieThemeColors } from "@classdojo/web/nessie/components/theme";
import * as React from "react";

const SmallCapsHeading: React.FC<React.PropsWithChildren<{ color?: NessieThemeColors }>> = ({ color, children }) => (
  <span
    sx={{
      textTransform: "uppercase",
      color: color || "dt_content_primary",
      fontSize: 12,
      fontWeight: 800,
      letterSpacing: "1.5px",
    }}
  >
    {children}
  </span>
);

export default SmallCapsHeading;
